import { createSelector } from '@reduxjs/toolkit';
import { ProjectsState } from 'ducks/projects/slices';
import { RootState } from 'store';

const projectsSlice = (state: RootState) => state.projects;

export const selectProjects = createSelector([projectsSlice], (state): ProjectsState => state);
